export default __webpack_public_path__ + "assets/images/f09211eeeb646a2759a8699c3d014fbe.jpg";